import { GPC, ValuationApproachModel } from 'api';
import { VALUATIONS_PUBLIC_COMPANIES_APPROACH } from 'pages/ValuationsAllocation/common/constants/valuations';
import { EQUITY_ATTRIBUTES_NEEDED } from 'pages/ValuationsAllocation/common/constants/valuations/valuations';

/**
 * Validates if equity option data is available for all comparisons in a public comps approach.
 * Checks if any required equity attributes are null.
 *
 * This validation is needed for public comps approaches saved before the equity option
 * was deployed, which may have incomplete Capital IQ data.
 *
 * @param comps - Array of comparisons to validate
 * @returns true if all required equity attributes are present, false otherwise
 */
export const isEquityOptionAvailable = (comps: GPC[]): boolean => {
  if (!comps?.length) {
    return true;
  }

  const hasNullFieldInEquityValues = comps.some(comparison =>
    EQUITY_ATTRIBUTES_NEEDED.some(comparisonAttribute => comparison[comparisonAttribute] === null)
  );

  return !hasNullFieldInEquityValues;
};

/**
 * Determines if equity option should be displayed for an approach.
 * Only applies to public comps approaches with complete equity data.
 *
 * @param approach - The valuation approach to check
 * @returns true if equity option should be shown, false otherwise
 */
export const shouldDisplayEquityOption = (approach: ValuationApproachModel | null): boolean => {
  if (approach?.approach_type === VALUATIONS_PUBLIC_COMPANIES_APPROACH) {
    return isEquityOptionAvailable(approach.valuations_approach_gpc?.gpc_comparison ?? []);
  }
  return false;
};
